var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuitAppLogoWithName = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 70,
    viewBox: "0 0 242 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.1302 21.7684H104.918V29.0065H99.1302V55.8837H90.977V29.0065H85.1895V21.7684H90.977V17.9894C90.977 12.9234 95.976 9.59814 101.734 9.59814H104.918V16.7694C104.918 16.7694 102.418 16.7694 101.801 16.7694C101.778 16.7694 101.689 16.7694 101.667 16.7694C100.261 16.8066 99.1302 17.9596 99.1302 19.373V21.7684ZM110.051 55.8837V21.7684H118.286V55.8837H110.051Z",
    fill: "#FF9F59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.719 33.1575V55.8911H147.484V33.894C147.484 30.9853 144.917 28.2105 140.662 28.2105C136.727 28.2105 133.841 30.9853 133.841 33.894V55.8911H125.606V21.7758H133.841V26.0086C135.09 24.0521 137.203 21.5824 141.481 21.0393C147.32 20.288 155.719 24.5803 155.719 33.1649V33.1575Z",
    fill: "#FF9F59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.938 55.8912V21.7759H170.173V55.8912H161.938Z",
    fill: "#FF9F59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.265 28.1882V46.0344C188.265 47.4479 189.455 48.6381 190.801 48.6381H194.052V55.8911H188.421C183.831 55.8911 180.03 52.1716 180.03 47.4999V28.1808H175.06V21.7535H180.03V9.59814H188.265V21.7535H194.052V28.1808H188.265V28.1882Z",
    fill: "#FF9F59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231.574 38.7593C231.574 50.0889 223.629 56.5608 214.658 56.6352C205.687 56.5608 197.742 50.1261 197.742 38.7593C197.742 27.3924 205.873 20.8833 214.658 20.8833C223.443 20.8833 231.574 27.4296 231.574 38.7593ZM223.302 38.7593C223.302 32.079 219.144 28.2107 214.658 28.1438C210.172 28.2107 206.014 32.0418 206.014 38.7593C206.014 45.923 210.276 49.3227 214.658 49.3822C219.04 49.3227 223.302 45.923 223.302 38.7593Z",
    fill: "#FF9F59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.562 18.1602V18.8073H233.724V23.613H232.98V18.8073H231.143V18.1602H235.562V18.1602Z",
    fill: "#FF9F59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.216 18.1602H237.273L238.842 22.7723L240.397 18.1602H241.446V23.613H240.739V20.3919C240.739 20.2803 240.739 20.0943 240.747 19.8414C240.747 19.581 240.747 19.3058 240.747 19.0157L239.192 23.613H238.463L236.893 19.0157V19.1793C236.893 19.3132 236.893 19.5141 236.901 19.7893C236.901 20.0645 236.908 20.2654 236.908 20.3919V23.613H236.202V18.1602H236.216Z",
    fill: "#FF9F59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.172 18.353C116.731 18.353 118.806 16.2781 118.806 13.7185C118.806 11.1589 116.731 9.08398 114.172 9.08398C111.612 9.08398 109.537 11.1589 109.537 13.7185C109.537 16.2781 111.612 18.353 114.172 18.353Z",
    fill: "#FF9F59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.836 18.353C168.395 18.353 170.47 16.2781 170.47 13.7185C170.47 11.1589 168.395 9.08398 165.836 9.08398C163.276 9.08398 161.201 11.1589 161.201 13.7185C161.201 16.2781 163.276 18.353 165.836 18.353Z",
    fill: "#FF9F59"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5118_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 13.8C3 6.73075 8.73076 1 15.8 1H54.2C61.2692 1 67 6.73076 67 13.8V52.2C67 59.2692 61.2692 65 54.2 65H15.8C8.73075 65 3 59.2692 3 52.2V13.8Z",
    fill: "#FF9F59"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5118_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6896 43.8631C31.7646 43.8631 36.6893 38.9384 36.6893 32.8635C36.6893 26.7885 31.7646 21.8638 25.6896 21.8638C19.6147 21.8638 14.6899 26.7885 14.6899 32.8635C14.6899 38.9384 19.6147 43.8631 25.6896 43.8631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3525 15.77V49.957C47.7946 49.957 55.446 42.3057 55.446 32.8635C55.446 23.4214 47.7946 15.77 38.3525 15.77V15.77Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5118_442",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5118_442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5118_442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5118_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.5982,
    height: 61.5982,
    fill: "white",
    transform: "translate(4.13025 2.13037)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuitAppLogoWithName);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/quit-app-logo-with-name.189c9bbe546cc511bb60e5aad0850571.svg";